<template>
  <div class="aroundCityWeather">
    <div class="publishTime">{{ publishTime }}</div>
    <el-carousel
      trigger="click"
      :autoplay="false"
      arrow="always"
      indicator-position="none"
    >
      <el-carousel-item v-for="item in dataArray" :key="item.chineseName">
        <div class="itemContainer">
          <div class="cityName">{{ item.chineseName }}</div>
          <img
            :src="require('../../assets/images/zbcount/' + item.imgUrl)"
            alt=""
          />
          <div class="text">
            <div class="temperature">{{ item.temperature }}</div>
            <div class="weather">{{ item.weather }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { home } from '../../api/index'
export default {
  created () {
    home.getAroundCityWeather().then(res => {
      // console.log(res);
      this.publishTime = res.pdate + ' 发布'
      for (const key in this.cityName) {
        for (const resKey in res.data) {
          if (resKey === key) {
            const tempObj = {
              chineseName: this.cityName[key],
              imgUrl: key + '.png',
              temperature: res.data[resKey][0].mint + '-' + res.data[resKey][0].maxt + '℃',
              weather: res.data[resKey][0].cont
            }
            this.dataArray.push(tempObj)
            break
          }
        }
      }
      // console.log(this.dataArray);
    })
  },

  data () {
    return {
      // 城市名
      cityName: {
        BFSG: '韶关',
        BFQY: '清远',
        BFFO: '佛山',
        BFHP: '惠州',
        BFZN: '中山',
        BFZH: '珠海',
        BFSE: '深圳',
        BFDG: '东莞'
      },

      // 发布时间
      publishTime: '',

      // 封装数据结构
      dataArray: []

    }
  }
}
</script>

<style lang="less" scoped>
.aroundCityWeather {
  position: relative;
  .publishTime {
    position: absolute;
    right: 5px;
    top: -45px;
    color: white;
    font-size: 12px;
  }
  .itemContainer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    font-size: 20px;
    img {
      width: 336px;
      height: 230px;
    }
    .text {
      display: flex;
      justify-content: space-around;
      width: 100%;
    }
  }
}
</style>
